export const isBetweenDates = (start: Date, end: Date): boolean => {
  const now = new Date().getTime();

  return now >= start.getTime() && now <= end.getTime();
};
